import { useState } from 'react'
// @ts-ignore
import classnames from 'classnames'
import { useQuery } from 'react-query'
import { omit } from 'lodash'
import { Col, Row } from 'react-bootstrap'
import { Modal, ModalBody } from 'components/modal'
import Link from 'components/link'
import Image from 'components/image'
// @ts-ignore
// @ts-ignore
import Quantity from 'components/quantity'
// @ts-ignore
import AddToCartButton from 'store/components/add-to-cart-button'
// @ts-ignore
import { getProduct } from 'store/api'
import Loader from 'components/loader'
import { successMessage } from 'lib/flash-message'
import { pdpPath } from 'lib/urls'
import SelectionControls from '../product-details-page/selection-controls'
import ProductInfo from '../product-details-page/product-info'

interface QuickViewModalProps {
  productId: number
  onHide(): void
  show: boolean
  onAddtoCartSuccess: any
}

const QuickViewModal = ({
  productId,
  onHide,
  show,
  onAddtoCartSuccess = () => {},
}: QuickViewModalProps) => {
  const { data, isLoading } = useQuery(productId, () => getProduct(productId), {
    refetchOnWindowFocus: false,
  })

  const handleOnAddToCartSuccess = () => {
    onAddtoCartSuccess()
    successMessage(`${data.genericProduct.shortName} added to cart!`)
    onHide()
  }

  return (
    <Modal show={show} onHide={onHide} title=" " size="small">
      <ModalBody>
        {!isLoading && data?.genericProduct && (
          <QuickViewModalContent
            genericProduct={data.genericProduct}
            onAddToCartSuccess={handleOnAddToCartSuccess}
          />
        )}
        {isLoading && (
          <div
            className="flex col align-center"
            style={{ minHeight: 260, width: '100%' }}
          >
            <Loader className="center-xy" style={undefined} />
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export const QuickViewModalContent = ({
  genericProduct,
  onAddToCartSuccess,
}: any) => {
  const {
    activeProductId,
    attributes,
    brand,
    id,
    isElectronicGiftCard,
    name,
    shortName,
    slug,
    products,
    productAttributeMap,
  } = genericProduct
  const [activeProduct, setActiveProduct] = useState(
    products[activeProductId] || null
  )
  const [quantity, setQuantity] = useState(1)
  const showQuantityLimit = activeProduct?.showPurchaseQuantityLimit || false
  const quantityLimit = activeProduct?.purchaseQuantityLimit || 10
  const productLinkUrl = pdpPath(slug, id, activeProduct.id)
  const disableAddToCart =
    activeProduct.merchandisingMessage === 'In Stock Soon'

  const pdpLinkDecorator = (child: any) => (
    <Link className="text-body" url={productLinkUrl} newWindow>
      {child}
    </Link>
  )

  return (
    <Row>
      <Col md={6}>
        {pdpLinkDecorator(
          <Image src={activeProduct?.images[0]?.url} width="100%" />
        )}
      </Col>
      <Col md={6}>
        <ProductInfo
          name={isElectronicGiftCard ? name : shortName}
          brand={brand}
          isElectronicGiftCard={isElectronicGiftCard}
          merchandisingMessage={activeProduct.merchandisingMessage || ''}
          price={activeProduct.price}
          productId={activeProduct.id}
          productType={activeProduct.productType}
          reviewSku={activeProduct.turntoSku}
          showPrice
          showDeferredPaymentMessage={false}
          showInStockNotificationLink={false}
          surchargeModalPrompt={null}
          extendedDeliveryTimeMessage={null}
          reactRouterEnabled={false}
          titleDecorator={pdpLinkDecorator}
        />
        <SelectionControls
          allAttributes={attributes}
          attributeLabelOverrides={
            activeProduct.isCashFund ? { amount: 'goal' } : null
          }
          /* eslint-disable-next-line react/jsx-no-bind */
          onProductChange={(productId: any) =>
            setActiveProduct(products[productId])
          }
          productAttributeMap={productAttributeMap}
          selectedAttributes={omit(activeProduct.attributes, 'sizeOnCatalog')}
        />
        <Quantity
          className="mtm mbl"
          min={1}
          max={quantityLimit}
          onChange={(qty: number) => setQuantity(qty)}
          limit={showQuantityLimit ? quantityLimit : null}
          value={quantity}
        />
        <AddToCartButton
          productId={activeProduct.id}
          quantity={quantity}
          useInfoButtonStyle
          buttonStyle={{ pill: true, block: true }}
          style={undefined}
          onSuccess={onAddToCartSuccess}
          disabled={disableAddToCart}
        />
      </Col>
    </Row>
  )
}

export default QuickViewModal
